import React, { useEffect, useState } from "react";
import { Button, DatePicker, Flex, Select, Tabs } from "antd";
import api from "../../api";
import CustomModal from "../../components/modal/CustomModal";
import { IconAlertSquareRounded } from "@tabler/icons-react";
import CustomInput from "../../components/input/CustomInput";
import CustomTextarea from "../../components/input/CustomTextarea";
import { useToast } from "../../components/toast/toast";
import { useAuth } from "../../store/context/AuthContext";
import MassSmsTable from "./tabs/MassSmsTable";
import SmsTable from "./tabs/SmsTable";

const MassMessage = () => {
  const [filters, setFilters] = useState({
    to: "",
    status: null,
    refer: null,
  });
  const [data, setData] = useState([]);
  const [listData, setListData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [tablePagination, setTablePagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [phones, setPhones] = useState([]);
  const [sendAt, setSendAt] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const toast = useToast();
  const { user } = useAuth();

  const handleChange = (values) => {
    const cleaned = values.map((val) => val.trim());

    setPhones(cleaned);
  };

  const fetchData = async ({ page = 1, pageSize = 10 } = {}) => {
    setLoading(true);

    if (activeTab === "1") {
      const res = await api.get_mass_sms_list({ page, pageSize });

      if (res.status === 200) {
        setData(res.data.data);
        setTablePagination((prev) => ({
          ...prev,
          total: res.data.total,
          current: page,
          pageSize,
        }));
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
    } else if (activeTab === "2") {
      const res = await api.get_sms_list({
        ...filters,
        page,
        pageSize,
      });

      // console.log("sms res --->", res);

      if (res.status === 200) {
        setListData(res.data.data);
        setPagination((prev) => ({
          ...prev,
          total: res.data.total,
          current: page,
          pageSize,
        }));
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
    }

    setLoading(false);
  };

  const handleListChange = (pagination) => {
    fetchData({ page: pagination.current, pageSize: pagination.pageSize });
  };

  const handleTableChange = (pagination) => {
    fetchData({ page: pagination.current, pageSize: pagination.pageSize });
  };

  useEffect(() => {
    const page = 1;
    const pageSize =
      activeTab === "1" ? tablePagination.pageSize : pagination.pageSize;

    fetchData({ page, pageSize });

    if (activeTab === "1") {
      setTablePagination((prev) => ({ ...prev, current: 1 }));
    } else {
      setPagination((prev) => ({ ...prev, current: 1 }));
    }
  }, [filters, activeTab]);

  const onChangeTab = async (key) => {
    // console.log("Active Tab:", key);
    setActiveTab(key);
  };

  const clearData = () => {
    setShowModal(false);
    setTitle("");
    setMessage("");
    setPhones([]);
    setSendAt(null);
  };

  const SendSmsHandler = async () => {
    // console.log({
    //   title,
    //   message,
    //   phones,
    //   user_id: user.id || "",
    //   start_at: sendAt ? sendAt.toISOString() : null,
    // });
    setIsLoading(true);
    const res = await api.send_sms({
      title,
      message,
      phones,
      user_id: user.id || "",
      started_at: sendAt ? sendAt.toISOString() : null,
    });
    if (res.status === 200) {
      toast("Амжилттай илгээгдлээ", "success");
      clearData();
      handleTableChange(tablePagination);
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  const items = [
    {
      key: "1",
      label: "Масс мессеж",
      children: (
        <MassSmsTable
          data={data}
          loading={loading}
          pagination={tablePagination}
          handleTableChange={handleTableChange}
        />
      ),
    },
    {
      key: "2",
      label: "Жагсаалт",
      children: (
        <SmsTable
          data={listData}
          loading={loading}
          filters={filters}
          setFilters={setFilters}
          pagination={pagination}
          handleTableChange={handleListChange}
        />
      ),
    },
  ];

  return (
    <Flex vertical gap="20px">
      <Button
        type="primary"
        style={{ width: "200px", alignSelf: "flex-end", height: "40px" }}
        onClick={() => setShowModal(true)}
      >
        Мессеж илгээх
      </Button>

      <Tabs defaultActiveKey="1" items={items} onChange={onChangeTab} />

      <CustomModal
        title={"Мессеж илгээх"}
        open={showModal}
        width={500}
        onCancel={() => {
          clearData();
        }}
        footer={[
          <Button
            key={"submit"}
            type="primary"
            style={{ height: "40px", padding: "0 50px" }}
            onClick={SendSmsHandler}
            disabled={
              !isLoading && title && message && phones.length ? false : true
            }
          >
            Илгээх
          </Button>,
        ]}
      >
        <Flex vertical gap={"10px"}>
          <Flex
            style={{
              backgroundColor: "#fff6cc",
              padding: "15px",
              borderRadius: "4px",
            }}
            align="flex-start"
            gap={"10px"}
          >
            <IconAlertSquareRounded
              strokeWidth={1.5}
              color="#5f5c73"
              style={{
                width: "36px",
                height: "36px",
                padding: 0,
                margin: 0,
              }}
            />
            <Flex vertical align="flex-start" gap={"10px"}>
              <p style={{ color: "#5f5c73" }}>
                Мессеж илгээхээс өмнө callpro-с өдрийн хязгаарыг шалгаж тооцоолж
                явуулна уу
              </p>
              <ul style={{ padding: 0, margin: 0, color: "#5f5c73" }}>
                <li>
                  Мессеж тэмдэгтүүд 145 ширхэгээс хэтрэх үед 2 мессеж болж
                  явахыг анхаарна уу.
                </li>
                <li>
                  Илгээхээс өмнө нэг удаадаа өөрлүүгээ тест хийж шалгана уу.
                </li>
                <li>Нэг удаадаа 500 гаас ихгүй дугаарлуу илгээнэ үү.</li>
                <li>Мессежээ зөвхөн латин үсгээр бичнэ үү.</li>
                <li>Мессежний ард "Grand Systems" үг автоматаар орно.</li>
              </ul>
            </Flex>
          </Flex>
          <CustomInput
            required
            title={"Гарчиг"}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <CustomTextarea
            required
            title={"Мессеж"}
            showCount
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ resize: "none" }}
          />

          <Flex vertical gap={"2px"} style={{ width: "100%" }}>
            <p style={{ fontSize: "13px" }}>
              <span style={{ color: "#f00" }}>*</span>
              Утасны дугаарууд: ({phones.length || "0"})
            </p>
            <Select
              className="scrollable-tags-select"
              mode="tags"
              style={{ width: "100%" }}
              placeholder="Утасны дугаарууд оруулна уу"
              value={phones}
              onChange={handleChange}
              tokenSeparators={[",", " "]}
              suffixIcon={null}
              styles={{
                popup: {
                  root: { display: "none" },
                },
              }}
            />
          </Flex>
          <Flex vertical gap={"2px"} style={{ width: "100%" }}>
            <p style={{ fontSize: "13px" }}>
              <span style={{ color: "#f00" }}>*</span>
               Илгээх цаг:
            </p>
            <DatePicker
              showTime
              style={{ minHeight: "40px" }}
              value={sendAt}
              onChange={(value, dateString) => {
                // console.log("Selected Time: ", value);
                setSendAt(value);
              }}
            />
          </Flex>
        </Flex>
      </CustomModal>
    </Flex>
  );
};

export default MassMessage;
